import { fetchRequest, HTTPMethod } from './api';

export const getUserIp = () => {
    return fetchRequest(HTTPMethod.GET, 'https://ipinfo.io/json?token=690c565140587a');
};
